import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
// 修正匯入路徑，使用正確的 SchemaOrg 組件位置
import SchemaOrg from '../../components/feature/SchemaOrg';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [showScrollTop, setShowScrollTop] = useState(false);

  // 監聽滾動
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 返回頂部
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // 定義 FAQ 資料
  const faqs = [
    {
      category: '搬家準備',
      questions: [
        {
          question: '搬家需要提前多久預約？',
          answer: '建議提前 3-7 天預約，讓我們有充足時間安排人力與車輛。如果是急件搬家，我們也會盡力配合您的時間。旺季（6-8月、年底）建議提前 2 週預約。'
        },
        {
          question: '搬家前需要準備什麼？',
          answer: '建議先整理物品、丟棄不需要的東西、貴重物品自行保管、易碎品特別標示、提前通知管理員預約電梯、準備停車位等。我們也提供打包服務。'
        },
        {
          question: '可以幫忙打包嗎？',
          answer: '可以！我們提供專業打包服務，包含提供紙箱、氣泡紙等包材，以及專人到府打包。精緻搬家方案包含完整打包服務。'
        }
      ]
    },
    {
      category: '費用相關',
      questions: [
        {
          question: '搬家費用如何計算？',
          answer: '費用會根據搬運距離、樓層、物品數量、特殊狀況等因素計算。我們提供免費到府估價，給您最準確的報價，絕無隱藏費用。基本費用為雙邊電梯 $3,000 起。'
        },
        {
          question: '有哪些額外費用？',
          answer: '可能的額外費用包括：行軍費（車輛無法靠近）、轉乘電梯、特殊物品搬運（鋼琴、保險櫃）、夜間加成等。所有費用都會在估價時明確告知。'
        },
        {
          question: '付款方式有哪些？',
          answer: '我們接受現金、轉帳等多種付款方式。一般為服務完成後付款，大型搬家可能需要預付訂金。'
        }
      ]
    },
    {
      category: '服務範圍',
      questions: [
        {
          question: '服務範圍包含哪些地區？',
          answer: '我們主要服務新北市、台北市、桃園市、新竹市等地區。詳細服務區域請參考服務範圍頁面或直接聯繫我們。'
        },
        {
          question: '可以跨縣市搬家嗎？',
          answer: '可以！我們提供跨縣市長途搬家服務，費用會依照距離計算。歡迎來電諮詢詳細報價。'
        }
      ]
    },
    {
      category: '保險理賠',
      questions: [
        {
          question: '有投保嗎？',
          answer: '有的！我們有投保營業責任險，搬運過程中若有物品損壞，會依照保險條款進行理賠。'
        },
        {
          question: '物品損壞怎麼辦？',
          answer: '若發生物品損壞，請立即拍照記錄並通知我們。我們會依照保險條款進行理賠處理。建議貴重物品自行保管或加保。'
        }
      ]
    }
  ];

  // 過濾 FAQ
  const filteredFaqs = faqs.map(category => ({
    ...category,
    questions: category.questions.filter(q =>
      (selectedCategory === 'all' || category.category === selectedCategory) &&
      (searchQuery === '' || 
       q.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
       q.answer.toLowerCase().includes(searchQuery.toLowerCase()))
    )
  })).filter(category => category.questions.length > 0);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-teal-600 via-emerald-600 to-teal-700 overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-question-line text-xl"></i>
              <span className="font-medium">常見問題</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              搬家常見問題解答
            </h1>
            <p className="text-xl mb-8 text-white/90 max-w-3xl mx-auto">
              快速找到您需要的答案
            </p>
          </div>
        </div>
      </section>

      {/* 搜尋和分類 */}
      <section className="py-8 bg-white border-b border-gray-200 sticky top-0 z-20 shadow-md">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row gap-4">
            {/* 搜尋框 */}
            <div className="flex-1">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜尋問題..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-4 py-3 pl-12 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
              </div>
            </div>
            
            {/* 分類篩選 */}
            <div className="flex gap-2 overflow-x-auto">
              <button
                onClick={() => setSelectedCategory('all')}
                className={`px-4 py-2 rounded-full whitespace-nowrap transition-all ${
                  selectedCategory === 'all'
                    ? 'bg-teal-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                全部
              </button>
              {faqs.map((category) => (
                <button
                  key={category.category}
                  onClick={() => setSelectedCategory(category.category)}
                  className={`px-4 py-2 rounded-full whitespace-nowrap transition-all ${
                    selectedCategory === category.category
                      ? 'bg-teal-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category.category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ 列表 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredFaqs.length === 0 ? (
            <div className="text-center py-12">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <p className="text-gray-500 text-lg">找不到相關問題</p>
            </div>
          ) : (
            <div className="space-y-8">
              {filteredFaqs.map((category, categoryIndex) => (
                <div key={categoryIndex}>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-folder-line text-teal-600"></i>
                    {category.category}
                  </h2>
                  <div className="space-y-4">
                    {category.questions.map((faq, faqIndex) => {
                      const globalIndex = categoryIndex * 100 + faqIndex;
                      return (
                        <div
                          key={faqIndex}
                          className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow"
                        >
                          <button
                            onClick={() => setOpenIndex(openIndex === globalIndex ? -1 : globalIndex)}
                            className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                          >
                            <div className="flex items-start gap-3 flex-1">
                              <i className="ri-question-line text-teal-600 text-xl mt-1"></i>
                              <span className="font-semibold text-gray-900 text-lg">
                                {faq.question}
                              </span>
                            </div>
                            <i
                              className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform ${
                                openIndex === globalIndex ? 'rotate-180' : ''
                              }`}
                            ></i>
                          </button>
                          {openIndex === globalIndex && (
                            <div className="px-6 pb-4 pt-2">
                              <div className="pl-8 text-gray-600 leading-relaxed">
                                {faq.answer}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-teal-500 via-emerald-500 to-teal-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">還有其他問題？</h2>
          <p className="text-xl text-teal-50 mb-8">
            歡迎直接聯繫我們，專人為您解答
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081"
              className="inline-flex items-center justify-center bg-white text-teal-600 px-10 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-all shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-3 text-xl"></i>
              0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/sadiest018moving" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-green-500 text-white px-10 py-4 rounded-full text-lg font-bold hover:bg-green-600 transition-all shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap border-2 border-white"
            >
              <img 
                src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                alt="LINE" 
                className="w-6 h-6 mr-3"
              />
              官方 LINE 諮詢
            </a>
          </div>
        </div>
      </section>

      {/* 返回頂部按鈕 */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-24 right-8 bg-gradient-to-r from-teal-600 to-emerald-600 text-white w-12 h-12 rounded-full shadow-2xl hover:shadow-3xl transition-all hover:scale-110 z-50 flex items-center justify-center cursor-pointer"
          aria-label="返回頂部"
        >
          <i className="ri-arrow-up-line text-2xl"></i>
        </button>
      )}

      <Footer />
      
      {/* FAQ Schema */}
      <SchemaOrg
        type="FAQPage"
        data={{
          questions: faqs.map(category => 
            category.questions.map(q => ({
              question: q.question,
              answer: q.answer
            }))
          ).flat()
        }}
      />
    </div>
  );
};

export default FAQPage;